document.addEventListener("product:variant-change",function (e) {
  let eventVariant = e.detail.variant;
  
  let variantInfo = document.getElementById("_variantsdata-" + eventVariant.id);
  let variantDataset = variantInfo.dataset;
  let qty = variantDataset['qty'] - variantDataset['minqty'] ;
  

  let soldoutSpan = document.getElementById("_product-warning-soldout");
  let availableSpan = document.getElementById("_product-warning-available");

  console.error(variantDataset['qty']);
  document.getElementById("_stock").innerText = variantDataset['qty'];
  
  if (qty < 0) {
    soldoutSpan.style.display = "block";
    availableSpan.style.display = "none";
  } else {
    soldoutSpan.style.display = "none";
    availableSpan.style.display = "block";
  }
 
});

